import { Button } from "@/components/ui/button";
import { Card, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { useUpdateInvoice } from "@/queries/invoices/update";
import { InvoiceModes } from "@/types/utils";

import { useTranslation } from "react-i18next";

type Props = {
  invoiceId: string;
  onSelectInvoiceMode: (invoiceMode: InvoiceModes) => void;
  disabled?: boolean;
};

export const InvoiceModeCard = ({
  invoiceId,
  onSelectInvoiceMode,
  disabled = false,
}: Props) => {
  const { t } = useTranslation();
  const [updateInvoice] = useUpdateInvoice();

  const handleSelectInvoiceMode = async (invoiceMode: InvoiceModes) => {
    onSelectInvoiceMode(invoiceMode);

    await updateInvoice({
      invoiceId,
      isNettoInvoice: invoiceMode === InvoiceModes.Netto,
    });
  };

  return (
    <div className="flex justify-center items-center h-full">
      <Card>
        <CardHeader>
          <CardTitle>{t("which_invoice_mode")}</CardTitle>
        </CardHeader>
        <CardFooter className="flex gap-2 justify-end">
          <Button
            variant="outline"
            disabled={disabled}
            onClick={() => handleSelectInvoiceMode(InvoiceModes.Netto)}
          >
            {t("switch_to_netto_mode")}
          </Button>
          <Button
            variant="outline"
            disabled={disabled}
            onClick={() => handleSelectInvoiceMode(InvoiceModes.Brutto)}
          >
            {t("switch_to_brutto_mode")}
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};
